export const eventActions = {
  GET_ALL_EVENTS: 'GET_ALL_EVENTS',
  SAVE_ALL_EVENTS: 'SAVE_ALL_EVENTS',
  GET_FUTURE_EVENTS: 'GET_FUTURE_EVENTS',
  SAVE_FUTURE_EVENTS: 'SAVE_FUTURE_EVENTS',
  CREATE_EVENT: 'CREATE_EVENT',
  EDIT_EVENT: 'EDIT_EVENT',
};

export const getAllEvents = () => {
  return {
    type: eventActions.GET_ALL_EVENTS,
  };
};

export const saveAllEvents = events => {
  return {
    type: eventActions.SAVE_ALL_EVENTS,
    events,
  };
};

export const getFutureEvents = () => {
  return {
    type: eventActions.GET_FUTURE_EVENTS,
  };
};

export const saveFutureEvents = events => {
  return {
    type: eventActions.SAVE_FUTURE_EVENTS,
    events,
  };
};

export const createEvent = formData => {
  return {
    type: eventActions.CREATE_EVENT,
    formData,
  };
};

export const editEvent = (formData, id) => {
  return {
    type: eventActions.EDIT_EVENT,
    formData,
    id
  };
};
